import { PersonEmailSource as EmailSources } from "../generated/django-enums";
import { getGlobalHeadersAsObject } from "../global-headers";
import type { DRFListResponseWrapper } from "../types";

export { EmailSources };

export type PersonEmailBase = {
	email: string;
	person: number;
	source: number;
	priority?: number;
	valid?: boolean;
	has_opened?: boolean;
	category?: boolean;
	used?: boolean;
};

export type PersonEmail = PersonEmailBase & {
	id?: number;
	created: string;
	updated: string;
	source_name: string;
	category_str: string;
	best_emailperson: boolean;
	unopened: boolean;
	x_failed_recipients: boolean;
	auto_submitted: boolean;
	obsolete: boolean;
	current: boolean;
};

export const getPersonEmailsByPersonId = (
	personId: number
): Promise<DRFListResponseWrapper<PersonEmail[]>> => {
	return fetch(`/api/v2/persons/${personId}/emailaddress/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const createPersonEmailByPersonId = (
	personId: number,
	emailAddress: string
): Promise<PersonEmail> => {
	const personEmail: PersonEmailBase = {
		email: emailAddress,
		person: personId,
		source: EmailSources.MANUAL,
	};

	return fetch(`/api/v2/persons/${personId}/emailaddress/`, {
		method: "POST",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(personEmail),
	}).then((res) => {
		if (res.status >= 400 && res.status < 600) {
			throw new Error(res.statusText);
		}
		return res.json();
	});
};

export const deletePersonEmailByPersonId = (
	personId: number,
	emailAddressId: number
) => {
	return fetch(`/api/v2/persons/${personId}/emailaddress/${emailAddressId}/`, {
		method: "DELETE",
		headers: {
			...getGlobalHeadersAsObject(),
		},
	}).then((res) => {
		if (res.status >= 400 && res.status < 600) {
			throw new Error(res.statusText);
		}
		return res;
	});
};

export const updatePersonEmailAddress = (
	personId: number,
	emailAddressId: number,
	personEmail: PersonEmailBase
) => {
	return fetch(`/api/v2/persons/${personId}/emailaddress/${emailAddressId}/`, {
		method: "PATCH",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(personEmail),
	}).then((res) => {
		if (res.status >= 400 && res.status < 600) {
			throw new Error(res.statusText);
		}
		return res;
	});
};
